import { ContextMenu, type ContextMenuItem } from 'cpool-components/general/ContextMenu';
import { Button } from 'cpool-components/input/Button';
import { ButtonVariant } from 'cpool-components/input/Button/types';
import { LuPlus } from 'react-icons/lu';

type Props<T extends string> = {
    ariaLabel: string;
    getLabel: (type: T) => string;
    itemTypes: readonly T[];
    onAdd: (type: T) => void;
};

export function AddContextMenu<T extends string>({
    ariaLabel,
    getLabel,
    itemTypes,
    onAdd,
}: Props<T>): React.ReactElement {
    const menuItems: ContextMenuItem[] = itemTypes.map((type) => ({
        id: type,
        label: getLabel(type),
        onClick: () => onAdd(type),
    }));

    return (
        <ContextMenu
            items={menuItems}
            maxHeight={itemTypes.length * 32 + 10}
            panelWidth={280}
            trigger={
                <Button
                    ariaLabel={ariaLabel}
                    className="h-8 w-8 shrink-0"
                    iconLeft={<LuPlus size={14} />}
                    type="button"
                    variant={ButtonVariant.SECONDARY}
                />
            }
        />
    );
}
